// Dev-only debug helpers for clearing service workers, caches, and logging storage state
/* eslint-disable no-console */
export async function clearServiceWorkersAndCaches() {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      for (const r of regs) {
        try { await r.unregister(); console.log('[devDebug] Unregistered service worker', r); } catch (e) { console.warn('[devDebug] Failed to unregister SW', e); }
      }
    }
  } catch (e) {
    console.warn('[devDebug] Error while unregistering service workers', e);
  }

  try {
    if (window.caches && typeof window.caches.keys === 'function') {
      const keys = await caches.keys();
      await Promise.all(keys.map(k => caches.delete(k)));
      console.log('[devDebug] Cleared cache keys:', keys);
    }
  } catch (e) {
    console.warn('[devDebug] Error while clearing caches', e);
  }

  try {
    // Also try clearing localStorage/sessionStorage if available
    if (typeof localStorage !== 'undefined') {
      console.log('[devDebug] localStorage length before clear:', localStorage.length);
      // Tutorial state cleanup removed (tutorial system removed)
    }
  } catch (e) {
    console.warn('[devDebug] localStorage access blocked or failed', e);
  }

  return true;
}

// logTutorialStorageState removed (tutorial system removed)

const devDebugUtils = {
  clearServiceWorkersAndCaches,
};

export default devDebugUtils;
